import { Layout, Menu, Typography, Avatar, Tag } from 'antd';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import {
  BarChartOutlined, HomeOutlined, UserOutlined, ShopOutlined,
  AppstoreOutlined, ShoppingCartOutlined, FileTextOutlined,
  DollarOutlined, AuditOutlined, BankOutlined, SoundOutlined,
  CarOutlined, SafetyOutlined, TeamOutlined, SettingOutlined
} from '@ant-design/icons';
import { getUser } from '../utils/auth';
import { useTheme } from '../contexts/ThemeContext';

// Pages
import GovDashboard from '../pages/admingov/GovDashboard';
import GovUsersPage from '../pages/admingov/GovUsersPage';
import GovBusinessPage from '../pages/admingov/GovBusinessPage';
import GovServicesPage from '../pages/admingov/GovServicesPage';
import GovOrdersPage from '../pages/admingov/GovOrdersPage';
import GovReportsPage from '../pages/admingov/GovReportsPage';
import GovTariffsPage from '../pages/admingov/GovTariffsPage';
import TaxAnalysisPage from '../pages/admingov/TaxAnalysisPage';
import TaxVendorDetail from '../pages/admingov/TaxVendorDetail';
import TaxRiskAnalysis from '../pages/admingov/TaxRiskAnalysis';

const { Header, Content, Sider } = Layout;
const { Title, Text } = Typography;

const ROLE_INFO = {
  1: { label: 'Admin', color: '#f5222d' },
  5: { label: 'Statistika', color: '#1890ff' },
  6: { label: 'Prokuratura', color: '#722ed1' },
  7: { label: 'Soliq', color: '#fa8c16' },
  8: { label: "O'zbek konsert", color: '#eb2f96' },
  9: { label: 'Transport boshqarmasi', color: '#52c41a' },
  10: { label: 'YHX boshqarmasi', color: '#13c2c2' },
  11: { label: 'Xodim', color: '#595959' },
};

const GovLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDark } = useTheme();
  const user = getUser();
  const roleId = user?.roles_id;
  const roleInfo = ROLE_INFO[roleId] || { label: 'Noma\'lum', color: '#999' };

  // Admin (1) — to'liq menyu; Qolganlar — tahliliy sahifalar
  const menuItems = [];

  // Hammaga ochiq
  menuItems.push({ key: '/admingov', icon: <BarChartOutlined />, label: 'Statistika' });

  // Faqat Admin uchun CRUD
  if (roleId === 1) {
    menuItems.push(
      { key: '/admingov/users', icon: <UserOutlined />, label: 'Foydalanuvchilar' },
      { key: '/admingov/businesses', icon: <ShopOutlined />, label: 'Bizneslar' },
      { key: '/admingov/services', icon: <AppstoreOutlined />, label: 'Xizmatlar' },
      { key: '/admingov/orders', icon: <ShoppingCartOutlined />, label: 'Buyurtmalar' },
      { key: '/admingov/reports', icon: <FileTextOutlined />, label: 'Shikoyatlar' },
      { key: '/admingov/tariffs', icon: <DollarOutlined />, label: 'Tariflar' },
    );
  }

  // Soliq (7) va Admin
  if (roleId === 7 || roleId === 1) {
    menuItems.push({ key: '/admingov/tax/risk', icon: <SafetyOutlined />, label: 'Havf tahlili' });
    menuItems.push({ key: '/admingov/tax', icon: <AuditOutlined />, label: 'Soliq Tahlil' });
  }

  menuItems.push(
    { type: 'divider' },
    { key: '/', icon: <HomeOutlined />, label: 'Saytga qaytish' },
  );

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ background: '#001529', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <BankOutlined style={{ color: '#fff', fontSize: 22 }} />
          <Title level={4} style={{ color: '#fff', margin: 0 }}>Davlat Boshqaruv Paneli</Title>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Tag color={roleInfo.color}>{roleInfo.label}</Tag>
          <Text style={{ color: 'rgba(255,255,255,0.7)' }}>{user?.fullname}</Text>
        </div>
      </Header>
      <Layout>
        <Sider width={240} style={{ background: 'var(--qk-card-bg)', borderRight: '1px solid var(--qk-border)' }} breakpoint="lg" collapsedWidth={60} theme={isDark ? 'dark' : 'light'}>
          <Menu
            mode="inline"
            theme={isDark ? 'dark' : 'light'}
            selectedKeys={[location.pathname]}
            items={menuItems}
            onClick={({ key }) => navigate(key)}
            style={{ height: '100%', borderRight: 0, paddingTop: 16, background: 'transparent' }}
          />
        </Sider>
        <Content style={{ padding: 24, background: 'var(--qk-bg)', overflow: 'auto' }}>
          <div style={{ maxWidth: 1400, margin: '0 auto' }}>
            <Routes>
              <Route index element={<GovDashboard />} />
              {roleId === 1 && (
                <>
                  <Route path="users" element={<GovUsersPage />} />
                  <Route path="businesses" element={<GovBusinessPage />} />
                  <Route path="services" element={<GovServicesPage />} />
                  <Route path="orders" element={<GovOrdersPage />} />
                  <Route path="reports" element={<GovReportsPage />} />
                  <Route path="tariffs" element={<GovTariffsPage />} />
                </>
              )}
              {(roleId === 7 || roleId === 1) && (
                <>
                  <Route path="tax/risk" element={<TaxRiskAnalysis />} />
                  <Route path="tax" element={<TaxAnalysisPage />} />
                  <Route path="tax/vendor/:id" element={<TaxVendorDetail />} />
                </>
              )}
              <Route path="*" element={<GovDashboard />} />
            </Routes>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default GovLayout;
